<div class="surface-ground flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden" [ngStyle]="backgroundStyle"
  style="min-height: 100vh; min-width: 100vw;">
    <section class="login ">
        <div class="container-login">
            <div class="login-card  auth-body ">
                <form class="md-float-material" (ngSubmit)="submitLogin(formLogin)" #formLogin="ngForm" novalidate>
                    <div class="text-center">
                        <img src="../assets/images/logo_login.png" alt="logo.png">
                    </div>
                    <div class="auth-box">
                        <div class="row m-b-20">
                            <div class="col-md-12">
                                <h3 class="text-left txt-primary" *ngIf="!traduccion"> Iniciar Sesión </h3>
                                <h3 class="text-left txt-primary" *ngIf="traduccion">
                                    {{"seccion.iniciarsesion.titulo" | translate}}
                                </h3>
                            </div>
                        </div>
                        <hr />
                        <div class="input-group">
                            <input 
                                type="text" 
                                class="form-control" 
                                (paste)="$event.preventDefault()"
                                placeholder='Usuario' 
                                name="Login"
                                [(ngModel)]="loginForm.Login" 
                                *ngIf="!traduccion" 
                                maxlength="25">
                            <input 
                                type="text" 
                                class="form-control" 
                                (paste)="$event.preventDefault()"
                                placeholder='{{ "input.usuario" | translate }}'
                                name="Login" [(ngModel)]="loginForm.Login" 
                                *ngIf="traduccion" 
                                maxlength="25">
                            <span class="md-line"></span>
                        </div>
                        <div class="input-group">
                            <input 
                                type="password" 
                                class="form-control" 
                                placeholder='Contraseña' 
                                name="Password"
                                [(ngModel)]="loginForm.Password" 
                                *ngIf="!traduccion" 
                                minlength="6">
                            <input 
                                type="password" 
                                class="form-control" 
                                placeholder='{{ "input.password" | translate }}'
                                name='Password' 
                                [(ngModel)]="loginForm.Password" 
                                *ngIf="traduccion" 
                                minlength="6">
                            <span class="md-line"></span>
                        </div>
                        <span 
                            *ngIf="loginForm.Password && loginForm.Password.length < 6"
                            style="color: red; margin-top: 10px;">
                            La contraseña debe tener al menos 6 caracteres.
                        </span>
                        <div class="row m-t-30">
                            <div class="col-md-12">
                                <button 
                                    type="submit"
                                    class="btn btn-primary btn-md btn-block waves-effect text-center m-b-20"
                                    *ngIf="!traduccion">
                                    Iniciar Sesión
                                </button>
                                <button 
                                    type="submit"
                                    class="btn btn-primary btn-md btn-block waves-effect text-center m-b-20"
                                    *ngIf="traduccion">
                                    {{ "botones.iniciarsesion" | translate}}
                                </button>
                            </div>
                        </div>
                        <div class="row m-t-25 text-left">
                            <div class="col-sm-12 col-xs-12 forgot-phone text-right">
                                <a 
                                    routerLink="resetpass" 
                                    class="text-right f-w-600 text-inverse"> 
                                    ¿Olvidaste tu Contraseña?
                                </a>
                            </div>
                        </div>
                        <hr />
                        <div class="row" *ngIf="traduccion">
                            <div class="col-md-2">
                                <i class="flag-icon flag-icon-mx m-r-5" *ngIf="lang == 'es'"></i>
                                <i class="flag-icon flag-icon-us m-r-5" *ngIf="lang == 'en' "></i>
                                <i class="flag-icon flag-icon-fr m-r-5" *ngIf="lang == 'fr' "></i>
                                <i class="flag-icon flag-icon-pt m-r-5" *ngIf="lang == 'pt' "></i>
                            </div>
                            <div class="col-md-10">
                                <select 
                                    class="float-right" #langSelect 
                                    (change)="toogleLanguage(langSelect.value)">
                                    <option 
                                        value="es" 
                                        [selected]="lang == 'es'"> 
                                        {{ "seccion.comun.spanishLabel" | translate }} 
                                    </option>
                                    <option 
                                        value="en" 
                                        [selected]="lang == 'en'">
                                        {{ "seccion.comun.englishLabel" | translate }} 
                                    </option>
                                    <option 
                                        value="fr" 
                                        [selected]="lang == 'fr'"> 
                                        {{ "seccion.comun.frenchLabel" | translate}} 
                                    </option>
                                    <option 
                                        value="pt" 
                                        [selected]="lang == 'pt'"> 
                                        {{ "seccion.comun.portuguesLabel" | translate }} 
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <footer class="footer">
                <div class="info-spot-footer row text-center w-100 m-0">
                    <span class="col-12 col-md-2">Versión 2.0</span>
                    <span class="d-none d-md-block col-md-2"></span>
                    <span class="col-12 col-md-2">Soporte técnico</span>
                    <span class="col-12 col-md-4 d-inline-flex align-items-center justify-content-center">
                        <svg style="margin-right: 8px;" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                            fill="currentColor" class="bi bi-envelope me-2" viewBox="0 0 16 16">
                            <path
                                d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741zM1 11.105l4.708-2.897L1 5.383z" />
                        </svg>
                        soporteycalidad@spot-itpro.com
                    </span>
                    <span class="col-12 col-md-2 d-inline-flex align-items-center justify-content-center">
                        <svg style="margin-right: 4px;" xmlns="http://www.w3.org/2000/svg" width="17" height="17"
                            fill="currentColor" class="bi bi-phone me-2" viewBox="0 0 16 16">
                            <path
                                d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
                            <path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
                        </svg>
                        +52(55)5336 4391
                    </span>
                </div>
            </footer>
        </div>
    </section>
</div>